// src/queries/pages/dashboard/holdsApiConfig.js

import { STALE_TIME, GC_TIME } from "@/queries/queryTimeConfig";

/**
 * HOLDS API CONFIGURATION
 * Uses pms-api REST endpoints for room hold management.
 */
export const holdsConfig = {
  /* ─── GET ─── */

  getUserHolds: {
    key: "getUserHolds",
    url: "/api/v1/holds/my",
    method: "GET",
    options: {
      staleTime: STALE_TIME.REALTIME,
      gcTime: GC_TIME.SHORT,
      refetchOnWindowFocus: true,
      refetchInterval: 30_000,
      keepPreviousData: true,
    },
  },

  /* ─── POST ─── */

  createHold: {
    key: "createHold",
    url: "/api/v1/holds",
    method: "POST",
    options: {
      retry: 0,
      invalidateKeys: [
        "getCalendarData",
        "checkAvailability",
        "getUserHolds",
      ],
    },
  },

  /* ─── PATCH ─── */

  updateHold: {
    key: "updateHold",
    url: (data) => `/api/v1/holds/${data.holdId}`,
    method: "PATCH",
    options: {
      retry: 0,
      invalidateKeys: ["getUserHolds"],
    },
  },

  refreshHold: {
    key: "refreshHold",
    url: (data) => `/api/v1/holds/${data.holdId}/refresh`,
    method: "PATCH",
    options: {
      retry: 1,
      invalidateKeys: ["getUserHolds"],
    },
  },

  /* ─── DELETE ─── */

  releaseHold: {
    key: "releaseHold",
    url: (data) => `/api/v1/holds/${data.holdId}`,
    method: "DELETE",
    options: {
      retry: 1,
      invalidateKeys: [
        "getCalendarData",
        "checkAvailability",
        "getUserHolds",
      ],
    },
  },
};
